import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { TimeOccurrenceEngine } from '../engines/time/time_engine';
import { IValidation, ICorrector, IValidator } from './contracts';

angular
  .module('ui-ng-calendar')
  .factory(
    'timeOverlapValidatorFactory',
    function (
      ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
      ngTimeOccurrenceEngine: TimeOccurrenceEngine,
      removeTimeOccurrenceCorrectorFactory: Function,
      reconcileOverlappingTimesCorrectorFactory: Function
    ) {
      return (
          originalTimeOccurrence: ITimeOccurrenceDatatype,
          currentTimeOccurrence: ITimeOccurrenceDatatype
        ): IValidator =>
        (store: ITimeOccurrenceDatatype[]): IValidation => {
          // check if dragging time conflicts with other existing times, revert if it does
          const dataStoreWithoutOriginal: ITimeOccurrenceDatatype[] = _.filter(
            store,
            (occurrence: ITimeOccurrenceDatatype) => {
              return occurrence.trackingId !== originalTimeOccurrence.trackingId;
            }
          );

          // the following is a hack and should be fixed
          const dataStoreWithOutCorrected: ITimeOccurrenceDatatype[] = _.filter(
            dataStoreWithoutOriginal,
            (occurrence: ITimeOccurrenceDatatype) => {
              return occurrence.trackingId !== (parseInt(currentTimeOccurrence.trackingId, 10) + 1).toString();
            }
          );

          const dataStoreWithoutCurrent: ITimeOccurrenceDatatype[] = _.filter(
            store,
            (occurrence: ITimeOccurrenceDatatype) => {
              return occurrence.trackingId !== currentTimeOccurrence.trackingId;
            }
          );

          // check that it doesn't overlap with OTHERS in the store (we CAN overlap with self)
          const doesCurrentTimeOverlapWithAnyInFilteredStore: boolean = ngTimeOccurrenceEngine.doesTimeOverlapWithTimes(
            currentTimeOccurrence,
            dataStoreWithOutCorrected
          );

          // to prevent just clicking on time and doing anything; if it's fully overlapping
          const isCurrentTimeSameTimeAsOriginal: boolean = ngTimeOccurrenceEngine.areTimesFullyOverlapping(
            currentTimeOccurrence,
            originalTimeOccurrence
          );

          const isCurrentTimeWithinTimeInFilteredStore: boolean = _.some(
            _.map(dataStoreWithoutCurrent, (timeOccurrence) =>
              ngTimeOccurrenceEngine.isTimeWithinTime(currentTimeOccurrence, timeOccurrence)
            )
          );

          const isValid = !doesCurrentTimeOverlapWithAnyInFilteredStore && !isCurrentTimeSameTimeAsOriginal;

          if (isValid) {
            return {
              isValid,
              corrector: removeTimeOccurrenceCorrectorFactory(originalTimeOccurrence)
            };
          } else if (!isCurrentTimeSameTimeAsOriginal && !isCurrentTimeWithinTimeInFilteredStore) {
            // revert if current time is same as original
            const overlappingTimes = ngTimeOccurrenceEngine.findOverlappingTimes(
              currentTimeOccurrence,
              dataStoreWithoutOriginal
            );
            return {
              isValid: true,
              corrector: reconcileOverlappingTimesCorrectorFactory(
                overlappingTimes,
                currentTimeOccurrence,
                originalTimeOccurrence
              )
            };
          } else {
            return {
              isValid
            };
          }
        };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/validation/time_overlap_validator.ts